VariationsWidget = window.VariationsWidget ?= {}
VariationsWidget.Collections ?= {}
VariationsWidget.Collections.Option ?= {}
VariationsWidget.Models ?= {}

VariationsWidget.Models.Option = require './option'

VariationsWidget.Collections.Option = Backbone.Collection.extend
  model: VariationsWidget.Models.Option

  chosen: (value) ->
    @find (trait) -> trait.get('traitValue') == value

  selected: ->
    @find (trait) -> trait.get('selected')

  setSelected: (id) ->
    @selected().set('selected', false)
    @get(id).set('selected', true)

VariationsWidget.Collections.Option.create = (traits) ->
  for trait in traits
    data = for option in trait.data
      traitValue: option.value
      disabled: false
      forceDisplay: false
      traitIndex: option.traitIndex
      traitName: option.name
      id: option.optionIndex
      isSoldOut: option.isSoldOut
      isUnavailable: option.isUnavailable
      optionPrice: false
      selected: option.optionIndex == 0
    new VariationsWidget.Collections.Option data


module.exports = VariationsWidget.Collections.Option



// WEBPACK FOOTER //
// ./modules/variations/frontend/models/option-collection.coffee